import { z } from 'zod';

export const zIconTyp = z.enum(['PENCIL', 'CLOCK', 'MAP_PIN']);

export const IconTyp = zIconTyp.enum;

export type IconTyp = z.infer<typeof zIconTyp>;
